


































































import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class groupItem extends Vue {
    get goodsDesc(){
      return this.$store.getters["goods/getSpecification"];
    }
    get tagOne(){
        if(this.goodsDesc.tagInfo){
            let tagObj=this.goodsDesc.tagInfo
            for (const key in tagObj) {
                if (tagObj[key].isShow) {
                    return tagObj[key]
                }
            }
        }
    }
    couponList:any=[]
    isCouponShow:Boolean = false
    created(){
        console.log(this.goodsDesc);
        if(this.goodsDesc.couponNumbers)//可领券标识
        this.getCouponList();
    }
    changeCouponShow(val:Boolean){
        this.isCouponShow = val;
    }
    getCouponList(){//获取可领取优惠券
        this.fetch({
          url: window.apis.getGoodsCouponList,
          data: {listId:this.goodsDesc.listId}
        }).then((data:any)=>{
            console.log(data);
            this.couponList = data || [];
        })
    }
    receiveCoupon(coupon:any){//领取优惠券
        this.fetch({
          url: window.apis.receiveCoupon ,
          data: {batchIdCipher:coupon.batchIdCipher}
        }).then((data:any)=>{
            console.log(data);
            this.$message({
                message: "优惠券已领取",
                type: "success",
            });
            this.isCouponShow = false;
        })
    }
}
